import React, { useEffect } from "react";

import OpenMenuButton, {
  OpenMenuButtonProps,
} from "@app/analytics/components/OpenMenuButton";
import TableCell from "@app/analytics/components/Table/TableCell";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

interface OptionsMenuCellProps extends OpenMenuButtonProps {
  id: string;
  forceClose?: boolean;
  menuItems: React.ReactNode[];
}

const OptionsMenuCell = ({
  forceClose = false,
  ...props
}: OptionsMenuCellProps) => {
  const anchorElement = useAnchorElement();

  useEffect(() => {
    if (forceClose) {
      anchorElement.onClose();
    }
  }, [forceClose]);

  return (
    <TableCell align="right" onClick={(e) => e.stopPropagation()}>
      <OpenMenuButton {...props} {...anchorElement} />
    </TableCell>
  );
};

export default OptionsMenuCell;
